<template>
  <div class="home">
    <div class="page">
      <Countdown countdown-time="2022-12-31 23:59:00+00:00" />
      <ApolloQuery
        :query="require('../graphql/PageQuery.gql')"
        :variables="{ data }"
      >
        <template slot-scope="{ result: { loading, error, data } }">
          <!-- Loading -->
          <div v-if="loading" class="loading apollo">Loading...</div>

          <!-- Error -->
          <div v-else-if="error" class="error apollo">An error occured</div>

          <!-- Result -->
          <div v-else-if="data" class="result apollo">
            <div v-for="item in data.page.body" v-bind:key="item.id">
              <!-- <div v-if="item.field === 'countdown'">
                <Countdown :countdown-time="item.rawValue" />
              </div> -->
              <div class="front-page">
                <div v-if="item.field === 'campaign_section'">
                  <ContentPage :content="item.blocks"></ContentPage>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-explorer'
                  "
                >
                  <OZGServiceExplorer></OZGServiceExplorer>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue ===
                        'ozg-implementation-status-graph-service-aggregation'
                  "
                >
                  <section class="page">
                    <b-container>
                      <b-row>
                        <b-col class="col-md-6 col-sm-12">
                          <OZGImplentationStatusGraph query="on-max-feature"
                        /></b-col> </b-row
                    ></b-container>
                  </section>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue ===
                        'ozg-implementation-status-max-feature-graph-service-aggregation'
                  "
                >
                  <section class="page">
                    <b-container>
                      <b-row>
                        <b-col class="col-md-6 col-sm-12">
                          <OZGImplentationStatusGraph query="on-max-feature"
                        /></b-col> </b-row
                    ></b-container>
                  </section>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue ===
                        'ozg-implementation-status-min-feature-graph-service-aggregation'
                  "
                >
                  <section class="page">
                    <b-container>
                      <b-row>
                        <b-col class="col-md-6 col-sm-12">
                          <OZGImplentationStatusGraph query="on-min-feature" />
                        </b-col> </b-row
                    ></b-container>
                  </section>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-implementation-fun-fact'
                  "
                >
                  <FunFactNumbers></FunFactNumbers>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-timeline-status-explorer'
                  "
                >
                  <OZGTimelineStatusExplorer></OZGTimelineStatusExplorer>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-city-ranking'
                  "
                >
                  <BestCityTable></BestCityTable>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-activity-comparison'
                  "
                >
                  <b-container>
                    <b-row>
                      <div class="col-sm-12 col-md-6 col-lg-6">
                        <OZGActivityHeatmap
                          statusType="PLANNING"
                          showLegend="false"
                        ></OZGActivityHeatmap>
                        <p style="text-align: center;">
                          Planungstermine von OZG-Leistungen
                        </p>
                      </div>

                      <div class="col-sm-12 col-md-6 col-lg-6">
                        <OZGActivityHeatmap
                          statusType="DONE"
                          showLegend="false"
                        ></OZGActivityHeatmap>
                        <p style="text-align: center">
                          Fertigstellungstermine von OZG-Leistungen
                        </p>
                      </div>
                    </b-row>
                  </b-container>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'federal-level-stats'
                  "
                >
                  <FederalLevelBubbles></FederalLevelBubbles>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-implementation-status-switch'
                  "
                >
                  <OZGImplementationLevelSwitchExplorer></OZGImplementationLevelSwitchExplorer>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue ===
                        'ozg-feature-part-of-reference-implementation'
                  "
                >
                  <OZGCountFeaturePartOfReferenceImplementation></OZGCountFeaturePartOfReferenceImplementation>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-feature-part-of-mvp'
                  "
                >
                  <OZGCountFeaturePartOfMVP></OZGCountFeaturePartOfMVP>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-milestone-count'
                  "
                >
                  <OZGMilestoneCount></OZGMilestoneCount>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-gantt-chart-explorer'
                  "
                >
                  <OZGAggregateGanttChatExplorer></OZGAggregateGanttChatExplorer>
                </div>
                <div
                  v-if="
                    item.field === 'chart_id' &&
                      item.rawValue === 'ozg-county-map'
                  "
                >
                  <OZGCountyMap></OZGCountyMap>
                </div>
                <div v-if="item.field === 'gallery'">
                  <PrototypeGallery :images="item.images"></PrototypeGallery>
                </div>
              </div>
            </div>
          </div>

          <!-- No result -->
          <div v-else class="no-result apollo">No result :(</div>
        </template>
      </ApolloQuery>
    </div>

    <footer>
      <div class="logo">
        <span class="stamp is-nope">Verdrusssache</span>
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src

import Countdown from "../components/Countdown";
import ContentPage from "../components/ContentPage";
import OZGServiceExplorer from "../components/explorers/OZGServiceExplorer";
import OZGImplentationStatusGraph from "../components/OZGImplentationStatusGraph";
import FunFactNumbers from "../components/numbers/funFactNumbers";
import FederalLevelBubbles from "../components/visualisations/FederalLevelBubbles";
import OZGCountFeaturePartOfMVP from "../components/numbers/OZGCountFeaturePartOfMVP";
import OZGCountFeaturePartOfReferenceImplementation from "../components/numbers/OZGCountFeaturePartOfReferenceImplementation";
import OZGMilestoneCount from "../components/numbers/OZGMilestoneCount";
import OZGActivityHeatmap from "../components/visualisations/OZGActivityHeatmap";
import OZGCountyMap from "../components/OZGCountyMap";
import PrototypeGallery from "../components/PrototypeGallery";
import OZGTimelineStatusExplorer from "../components/explorers/OZGTimelineStatusExplorer";
import OZGImplementationLevelSwitchExplorer from "../components/explorers/OZGImplementationLevelSwitchExplorer";
import BestCityTable from "../components/numbers/BestCityTable";
import OZGAggregateGanttChatExplorer from "../components/explorers/OZGAggregateGanttChatExplorer";
export default {
  name: "Home",
  metaInfo() {
    return {
      title: "OZG Dashboard",
      meta: [
        { name: 'description', property: 'og:description', content:  'Bis 2022 muss das Onlinezugangsgesetz umgesetzt sein. Ist das noch zu schaffen? Informationen und transparente Statistiken zum Stand der OZG-Umsetzung.'},
        { property: 'twitter:title', content: "OZG-Dashboard"},
        {name: 'image', property: 'og:image', content: "https://ozg.verdrusssache.de/preview.jpg"},
        {name: 'twitter:description', content: 'Bis 2022 muss das Onlinezugangsgesetz umgesetzt sein. Ist das noch zu schaffen? Informationen und transparente Statistiken zum Stand der OZG-Umsetzung.'},
        { property: 'twitter:card', content: 'summary_large_image'},
        {property: 'author', content: 'Lilith Wittmann'},
        {name: 'twitter:image', content: "https://ozg.verdrusssache.de/preview.jpg"},
      ]
    }
  },
  components: {
    BestCityTable,
    OZGServiceExplorer,
    PrototypeGallery,
    OZGCountyMap,
    OZGActivityHeatmap,
    FunFactNumbers,
    OZGImplentationStatusGraph,
    OZGAggregateGanttChatExplorer,
    ContentPage,
    Countdown,
    OZGTimelineStatusExplorer,
    OZGImplementationLevelSwitchExplorer,
    OZGMilestoneCount,
    OZGCountFeaturePartOfReferenceImplementation,
    OZGCountFeaturePartOfMVP,
    FederalLevelBubbles
  }
};
</script>

<style lang="scss">
h3 {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
}

h2 {
  font-family: "Open Sans", sans-serif;
  font-size: 14px !important;
  text-transform: uppercase;
  margin-top: 50px;

  color: #ffffff;
  background-color: #111111;
  display: inline-block;
  padding: 12px 15px 13px 15px;
}

.page {
  margin: 0;
  width: 100%;
}

.front-page {
  background-color: #fff !important;
}

.story {
  font-family: "Bitter", serif;
  font-weight: normal;
  word-wrap: break-word;
  font-size: 23px;
  line-height: 1.6em;
  background-color: #fff;
}

.story > p {
  -webkit-margin-before: 0em;
  -webkit-margin-after: 1.4em;
  margin-bottom: 1.4em;
}

.price-boxes {
  display: inline-block;
  justify-content: center;
}
.price-box {
  padding-top: 20px;
  min-width: 150px;
  height: 150px;
  background-color: #000;
  color: #fff;
  margin: 10px;
  text-align: center;
  vert-align: middle;
  @media (min-width: 992px) {
    min-width: 140px;
    margin: 8px;
  }
}

.price-box > .price {
  font-size: 2.5rem;
  text-align: center;
  font-family: "Open Sans Condensed", sans-serif;
  font-weight: 700;
}
.price-box > small {
  font-size: 0.8rem;
  line-height: 0.7rem;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
}

.numbers {
  background-color: #fff;
  font-style: italic;
  color: #000;
  padding: 10px;
}

.numbers.inverted {
  background-color: #000;
  color: #fff;
  a {
    color: #fff;
    text-decoration: underline;
  }
}

.numbers span {
  font-size: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
  font-family: "Open Sans Condensed", sans-serif;
  font-weight: 700;
  font-style: normal;
}

footer {
  height: 150px;
  margin-top: 10px;

  .logo {
    max-width: 400px;
    margin: 0 auto;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .stamp {
    transform: rotate(12deg);
    color: #555;
    font-size: 3rem;
    font-weight: 700;
    border: 0.25rem solid #555;
    display: inline-block;
    padding: 0.25rem 1rem;
    text-transform: uppercase;
    border-radius: 1rem;
    font-family: "Courier";
    -webkit-mask-image: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/8399/grunge.png");
    -webkit-mask-size: 944px 604px;
    mix-blend-mode: multiply;
  }

  .is-nope {
    color: #d23;
    border: 0.5rem solid #d23;
    transform: rotate(-3deg);
    -webkit-mask-position: 2rem 3rem;
    font-size: 2rem;
  }
}
</style>
